import React from 'react';
import { ContentMediaListBlock } from 'patterns/ContentMediaListBlock';
import { BlogList } from 'patterns/BlogList';
import { BookListBlock } from 'patterns/BookListBlock';
import { Masthead } from 'patterns/Masthead';
import { Shell } from 'patterns/Shell';
import { SubHeader } from 'patterns/SubHeader';
import { TechBlock } from 'patterns/TechBlock';
import { ProductBlock } from 'patterns/ProductBlock';

import '../scss/main.scss';

function BusinessLandingPage({
    location: {
        pathname,
    },
}) {
    const data = {
        masthead: {
            title: 'Business',
            description: [
                {
                    spans: [],
                    text: 'A collection of tools and products I use to run my successful (in my eyes) freelance business.',
                    type: 'paragraph',
                },
            ],
            image: {
                alt: '',
                dimensions: {
                    height: 3024,
                    width: 4032,
                },
                url: 'https://images.prismic.io/robsimpson/b654c40f-f586-4b69-8fdb-9ff3018fa444_about-office.jpg?auto=compress,format'
            },
        },
        blog: {
            items: [
                {
                    card_description: 'Reflecting on 2020 – a year that included the most change in my life personally and professionally for a long time.',
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 1024,
                            width: 768,
                        },
                        url: 'https://images.prismic.io/robsimpson/2f4a907b-376a-4174-8762-734975b18bd1_about-zoo.png?auto=compress,format'
                    },
                    card_link_url: {
                        link_type: 'Document',
                        uid: 'articles/2020-year-in-review',
                    },
                    card_title: {
                        text: '2020 year in review',
                    },
                },
                {
                    card_description: 'From the 7th September, I’ll be available for design and development projects on a full-time basis.',
                    card_image: {
                        alt: '',
                        dimensions: {
                            height: 3024,
                            width: 4032,
                        },
                        url: 'https://images.prismic.io/robsimpson/b654c40f-f586-4b69-8fdb-9ff3018fa444_about-office.jpg?auto=compress,format'
                    },
                    card_link_url: {
                        link_type: 'Document',
                        uid: 'articles/full-time-freelance-designer-developer',
                    },
                    card_title: {
                        text: 'Starting a new chapter as a full time freelancer',
                    },
                },
            ],
        },
        office: {
            overline: 'Office',
            title: 'Making over my office space for creative, productive work',
            content: [
                {
                    spans: [],
                    text: 'With such a small space I needed to be intentional with what I included.',
                    type: 'paragraph',
                },
                {
                    spans: [],
                    text: 'Key tech includes my 27” monitor which I connect to my Macbook Air (I also have a Mac Mini as a backup machine). I use the Google mesh wifi to boost my internet signal (otherwise I literally can’t do anything).',
                    type: 'paragraph',
                },
                {
                    spans: [],
                    text: 'I’ve also filled my office with a bunch of plants as being around nature is good for us.',
                    type: 'paragraph',
                },
            ],
            media:[
                {
                    media_image: {
                        alt: '',
                        dimensions: {
                            height: 1242,
                            width: 2484,
                        },
                        url: 'https://images.prismic.io/robsimpson/24870e23-7419-43a8-81b7-4c578913cadc_office.jpg?auto=compress,format'
                    },
                },
            ],
            products: [
                {
                    product_brand: 'LG',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/1389b161-e818-4d02-a4f5-325292cc8922_monitor.jpg?auto=compress,format'
                    },
                    product_name: 'Monitor',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.lg.com/uk/monitors/lg-27MD5KL',
                    },
                },
                {
                    product_brand: 'Apple',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/5f4cd196-a3fa-4b2f-990f-53b121238050_macmini.jpg?auto=compress,format'
                    },
                    product_name: 'Mac mini',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/gp/product/B08N5NT8VF/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=robsimpson04-21&creative=6738&linkCode=as2&creativeASIN=B08N5NT8VF&linkId=7536ee752443115d7332fcb230122406',
                    },
                },
                {
                    product_brand: 'Apple',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/d5dd012c-b768-4718-ae9b-0ba281ebc307_macbookair.jpg?auto=compress,format'
                    },
                    product_name: 'MacBook Air',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/Apple-MacBook-Chip-13-inch-256GB/dp/B08N5N1WBH/',
                    },
                },
                {
                    product_brand: 'Twelve South',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/ea8d765f-1623-44a4-be97-a0018bc60d74_laptopstand.jpg?auto=compress,format'
                    },
                    product_name: 'Laptop stand',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/gp/product/B07377XVNY/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=robsimpson04-21&creative=6738&linkCode=as2&creativeASIN=B07377XVNY&linkId=0d02bd95d71cc501a688d2566d762b84',
                    },
                },
                {
                    product_brand: 'Google',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/5173ee6d-9d7e-43b4-8e2a-1d316b592333_meshwifi.jpg?auto=compress,format'
                    },
                    product_name: 'Mesh wifi',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/gp/product/B07YSXZ7QD/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=robsimpson04-21&creative=6738&linkCode=as2&creativeASIN=B07YSXZ7QD&linkId=eb024f3bd7509b5d40797a672dc2d057',
                    },
                },
                {
                    product_brand: 'Sonos',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/e4e9430e-e982-4b3b-b5a2-8a793ac8c904_smartspeaker.jpg?auto=compress,format'
                    },
                    product_name: 'Smart speaker',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/gp/product/B07PJXG49Q/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=robsimpson04-21&creative=6738&linkCode=as2&creativeASIN=B07PJXG49Q&linkId=0300fcafc64db61050dd40ddfda879d4',
                    },
                },
                {
                    product_brand: 'Ikea',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/18d88449-c807-4ac1-a970-5e4f57351b40_desk.jpg?auto=compress,format'
                    },
                    product_name: 'Desk',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.ikea.com/gb/en/p/karlby-worktop-walnut-veneer-30335191/',
                    },
                },
                {
                    product_brand: 'Ebay',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/6d24073e-9c16-4077-b305-1514a4f8d90b_legs.jpg?auto=compress,format'
                    },
                    product_name: 'Legs',
                },
                {
                    product_brand: 'Ikea',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/3bc3bb11-30f8-446d-9be0-3a57755a6fda_chair.jpg?auto=compress,format'
                    },
                    product_name: 'Chair',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.ikea.com/gb/en/p/alefjaell-office-chair-grann-golden-brown-00419984/',
                    },
                },
                {
                    product_brand: 'Yeelight',
                    product_image: {
                        alt: '',
                        dimensions: {
                            height: 192,
                            width: 192,
                        },
                        url: 'https://images.prismic.io/robsimpson/c70eb841-d544-4daf-aa94-0395a62326f2_lightstrip.jpg?auto=compress,format'
                    },
                    product_name: 'Smart light strip',
                    product_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/gp/product/B09G2GQQNW/ref=as_li_qf_asin_il_tl?ie=UTF8&tag=robsimpson04-21&creative=6738&linkCode=as2&creativeASIN=B09G2GQQNW&linkId=4cbb850ef1a6fda5dd8c61dcf4978c1a',
                    },
                },
            ],
        },
        money: {
            overline: 'Money',
            title: 'Effectively managing your finances can be the difference between success or failure in business',
            content: [
                {
                    spans: [
                        {
                            start: 0,
                            end: 14,
                            type: "strong",
                        },
                        {
                            start: 160,
                            end: 171,
                            type: "strong",
                        },
                    ],
                    text: 'Monzo business is at the core of my business finances. All invoices are paid into here and 40% is automatically moved into a tax pot on payment. I currently use Quickbooks for sending out invoices, but I’m thinking about moving to Monzo’s invoicing functionality.',
                    type: 'paragraph',
                },
                {
                    spans: [
                        {
                            start: 27,
                            end: 34,
                            type: "strong",
                        },
                        {
                            start: 148,
                            end: 156,
                            type: "strong",
                        },
                    ],
                    text: 'To manage my pension I use Penfold – setup specifically for freelancers (although I think they have since shifted their positioning). Lastly, I use Moneybox for investments, this is connected to my personal bank account where the roundups are taken and invested.',
                    type: 'paragraph',
                },
            ],
            tech: [
                {
                    tech_category: 'Bank',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M5.65867 1.56511C5.5217 1.57901 5.3939 1.64032 5.29733 1.73844L0.004 7.03177L0.00266667 7.03311C5.18133 12.2091 10.7933 17.8224 15.6667 22.6971V11.2704L6.136 1.73977C6.07446 1.67696 5.99966 1.62869 5.91708 1.59847C5.8345 1.56825 5.74621 1.55685 5.65867 1.56511V1.56511ZM26.3027 1.56511C26.2216 1.56232 26.1408 1.57627 26.0653 1.60609C25.9898 1.63591 25.9213 1.68096 25.864 1.73844L16.3333 11.2744V22.6984L32 7.03311C30.2453 5.27044 28.4707 3.50244 26.7067 1.73977C26.6002 1.63231 26.4565 1.56979 26.3053 1.56511H26.3027ZM0 7.97177L0.00266667 22.5784C0.00266667 22.9704 0.16 23.3478 0.437333 23.6251L7.068 30.2598C7.44133 30.6358 8.08133 30.3704 8.07867 29.8411V16.0491L0 7.97177ZM31.9973 7.97577L23.9173 16.0571V29.8411C23.912 30.3731 24.5573 30.6411 24.9307 30.2598L31.5627 23.6251C31.84 23.3478 31.9973 22.9718 31.9973 22.5784V7.97577Z" /></svg>',
                    tech_name: 'Monzo',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://monzo.com/i/business/',
                    },
                },
                {
                    tech_category: 'Invoices',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0V0ZM16.856 5.51133C18.1299 5.51133 19.1621 6.546 19.1621 7.82227V19.9112H21.2955C23.4475 19.9112 25.1988 18.1571 25.1988 16.0005C25.1988 13.8441 23.4473 12.0895 21.2953 12.0895H20.4081V9.77787H21.2953C24.7249 9.77787 27.5056 12.5641 27.5056 16.0005C27.5056 19.4371 24.7249 22.2227 21.2953 22.2227H16.856V5.51133ZM10.6449 9.77733H15.0837V26.488C13.8097 26.488 12.7771 25.4535 12.7771 24.1771V12.0883H10.6449C8.49213 12.0883 6.74133 13.8429 6.74133 15.9995C6.74133 18.1561 8.49213 19.9105 10.6449 19.9105H11.5321V22.2215H10.6449C7.21493 22.2215 4.43467 19.4359 4.43467 15.9995C4.43467 12.5633 7.21493 9.77733 10.6449 9.77733V9.77733Z" /></svg>',
                    tech_name: 'Quickbooks',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://quickbooks.intuit.com/',
                    },
                },
                {
                    tech_category: 'Pension',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M3.88879 31.8947H10.8725V20.5469H13.1143C17.77 20.5469 20.9602 20.031 23.4605 18.5696C26.1333 17.0222 28.0301 14.1851 28.0301 10.2307C28.0301 5.93221 25.6159 3.18119 22.8569 1.71978C20.3566 0.430302 17.1665 0.0864258 13.3729 0.0864258H3.88879V31.8947ZM10.8725 14.8729V6.19018H13.2867C15.787 6.19018 17.5114 6.27609 18.7185 6.87793C20.1842 7.56556 20.9602 8.76913 20.9602 10.5745C20.9602 12.122 20.2704 13.3256 18.9771 14.0132C17.77 14.7009 16.218 14.787 13.4591 14.787H10.8725V14.8729Z"/></svg>',
                    tech_name: 'Penfold',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://getpenfold.com/',
                    },
                },
                {
                    tech_category: 'Investment',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M15.5737 19.5225C20.8965 19.5225 25.2115 15.2075 25.2115 9.88479C25.2115 4.56202 20.8965 0.24707 15.5737 0.24707C10.251 0.24707 5.93604 4.56202 5.93604 9.88479C5.93604 15.2075 10.251 19.5225 15.5737 19.5225Z"/><path d="M25.2115 31.7778C25.2115 30.5122 24.9622 29.259 24.4778 28.0897C23.9935 26.9204 23.2836 25.8579 22.3886 24.963C21.4937 24.068 20.4312 23.3581 19.2619 22.8738C18.0926 22.3894 16.8394 22.1401 15.5737 22.1401C14.3081 22.1401 13.0549 22.3894 11.8856 22.8738C10.7162 23.3581 9.6538 24.068 8.75886 24.963C7.86391 25.8579 7.154 26.9204 6.66966 28.0897C6.18532 29.259 5.93604 30.5122 5.93604 31.7778H25.2115Z"/></svg>',
                    tech_name: 'Moneybox',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://moneyboxapp.com/',
                    },
                },
            ],
        },
        management: {
            overline: 'Management',
            title: 'Keeping client and business tasks organised is a super power',
            content: [
                {
                    spans: [
                        {
                            start: 0,
                            end: 6,
                            type: "strong",
                        },
                    ],
                    text: 'Notion is my go to tool for keeping track of my business and client projects. I use it for scheduling, keeping track of clients, invoices, new leads and more.',
                    type: 'paragraph',
                },
                {
                    spans: [
                        {
                            start: 24,
                            end: 33,
                            type: "strong",
                        },
                        {
                            start: 69,
                            end: 78,
                            type: "strong",
                        },
                        {
                            start: 113,
                            end: 120,
                            type: "strong",
                        },
                    ],
                    text: 'Accompanying tools like 1Password, store all of my passwords, whilst Clockify is used to track time on projects. Dropbox takes care of all documents and assets.',
                    type: 'paragraph',
                },
                {
                    spans: [
                        {
                            start: 0,
                            end: 6,
                            type: "strong",
                        },
                        {
                            start: 76,
                            end: 85,
                            type: "strong",
                        },
                    ],
                    text: 'Ecosia is my prefered search engine – they plants trees when you search and Plausible is a privacy-focused analytics tool.',
                    type: 'paragraph',
                },
            ],
            tech: [
                {
                    tech_category: 'Project management',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M5.945 5.61c.995.809 1.368.747 3.238.622l17.62-1.057c.373 0 .062-.374-.062-.435l-2.928-2.116c-.56-.435-1.308-.933-2.74-.81L4.013 3.06c-.621.061-.746.373-.498.621l2.43 1.93Zm1.058 4.107v18.54c0 .995.497 1.368 1.618 1.306l19.364-1.12c1.122-.062 1.247-.747 1.247-1.556V8.472c0-.808-.31-1.244-.997-1.183L7.999 8.472c-.747.063-.996.436-.996 1.244v.001Zm19.116.994c.124.56 0 1.12-.56 1.184l-.934.187v13.685c-.81.436-1.557.685-2.18.685-.997 0-1.246-.312-1.993-1.244l-6.103-9.581v9.27l1.931.437s0 1.12-1.557 1.12l-4.296.247c-.124-.248 0-.87.436-.994l1.12-.31V13.138l-1.554-.125c-.125-.56.187-1.368 1.058-1.431l4.608-.31 6.352 9.704v-8.586l-1.62-.185c-.124-.686.373-1.183.996-1.245l4.296-.25ZM2.58 1.38 20.328.072c2.179-.186 2.74-.062 4.11.934l5.665 3.981c.933.684 1.245.87 1.245 1.617v21.838c0 1.368-.497 2.178-2.24 2.301L8.498 31.99c-1.307.063-1.931-.123-2.617-.995L1.71 25.58C.963 24.584.652 23.84.652 22.967V3.557c0-1.12.499-2.054 1.93-2.177Z"/></svg>',
                    tech_name: 'Notion',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://notion.so/',
                    },
                },
                {
                    tech_category: 'Password manager',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M14.013 13.35V9.733c0-.408.331-.739.739-.739H17.3c.408 0 .739.331.739.739v6.624c0 .101-.051.179-.102.255l-.637.637c-.153.153-.153.383 0 .51l.637.637a.328.328 0 0 1 .102.254v3.618c0 .408-.331.738-.739.738h-2.548a.739.739 0 0 1-.739-.738v-6.624c0-.102.051-.179.102-.255l.637-.637c.153-.154.153-.383 0-.51l-.637-.637a.325.325 0 0 1-.102-.253ZM25.503 16a9.503 9.503 0 1 0-19.006 0 9.503 9.503 0 0 0 19.006 0Zm3.006 0c0 6.904-5.605 12.484-12.484 12.484-6.904 0-12.484-5.605-12.484-12.484 0-6.904 5.606-12.484 12.484-12.484 6.879 0 12.484 5.58 12.484 12.484ZM1.02 16c0 8.28 6.7 14.981 14.981 14.981 8.281 0 14.981-6.701 14.981-14.981C30.981 7.72 24.28 1.019 16 1.019 7.72 1.019 1.019 7.72 1.019 16ZM0 16C0 7.159 7.159 0 16 0c8.841 0 16 7.159 16 16 0 8.841-7.159 16-16 16-8.841 0-16-7.159-16-16Z"/></svg>',
                    tech_name: '1Password',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://1password.com/',
                    },
                },
                {
                    tech_category: 'Time tracking',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M17.802 27.205c1.48 0 2.892-.296 4.185-.821l3.588 3.592A15.897 15.897 0 0 1 17.802 32c-8.83 0-15.99-7.164-15.99-16s7.16-16 15.99-16c2.795 0 5.42.72 7.705 1.982l-3.53 3.533a11.106 11.106 0 0 0-4.175-.818c-6.184 0-11.197 5.038-11.197 11.255 0 6.214 5.013 11.253 11.197 11.253Zm2.9-16.206 7.348-7.352 2.103 2.103-7.347 7.352-2.103-2.103Zm-2.976 7.513a2.608 2.608 0 0 1-2.603-2.615 2.609 2.609 0 0 1 2.603-2.615 2.609 2.609 0 0 1 2.602 2.615 2.608 2.608 0 0 1-2.602 2.615Zm12.461 7.594-2.103 2.104-7.347-7.352 2.103-2.104 7.347 7.352Z"/></svg>',
                    tech_name: 'Clockify',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://clockify.me/',
                    },
                },
                {
                    tech_category: 'Storage',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M8 2.41 0 7.504l8 5.096 8.001-5.096L8 2.41Zm16 0-8 5.095 8 5.096 8-5.096-8-5.096ZM0 17.697l8 5.096 8.001-5.096L8 12.602l-8 5.096Zm24-5.096-8 5.096 8 5.096 8-5.096-8-5.096ZM8 24.494l8.001 5.096 8-5.096-8-5.096L8 24.494Z"/></svg>',
                    tech_name: 'Dropbox',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://dropbox.com/',
                    },
                },
                {
                    tech_category: 'Email',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m16 1.088-16 9 16 9 16-9-16-9Z"/><path d="M0 30.088v-17.5l16 9.002 16-9.002v17.5H0Z"/></svg>',
                    tech_name: 'Polymail',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://polymail.io/',
                    },
                },
                {
                    tech_category: 'Browser',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 0A15.968 15.968 0 0 0 3.51 6.001l5.27 9.131A7.272 7.272 0 0 1 16 8.727h14.255A16 16 0 0 0 16 0ZM2.575 7.293A15.924 15.924 0 0 0 0 16c0 8.016 5.893 14.655 13.585 15.819l5.271-9.13a7.267 7.267 0 0 1-9.153-3.053L2.575 7.293Zm17.789 2.888a7.26 7.26 0 0 1 1.933 9.454l.003.001h-.003l-7.125 12.343c.275.013.55.021.828.021 8.836 0 16-7.164 16-16 0-2.053-.387-4.015-1.09-5.819H20.363ZM16 21.82a5.819 5.819 0 1 1 0-11.638 5.819 5.819 0 0 1 0 11.638Z"/></svg>',
                    tech_name: 'Google Chrome',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://google.co.uk/chrome/',
                    },
                },
                {
                    tech_category: 'Search engine',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 16c0 8.837-7.163 16-16 16C7.768 32 .989 25.784.099 17.79A15.93 15.93 0 0 0 1.9 23.562c.073-.07.146-.131.219-.193a3.41 3.41 0 0 0 .288-.262c.113-.196.238-.392.364-.589.138-.215.276-.432.4-.651.492-.3.963-.634 1.41-1.003.058-.175.13-.364.202-.554.073-.193.146-.387.206-.567.04-.12.146-.252.265-.4.233-.29.515-.64.443-1.074-.162-.57-.67-.836-1.189-1.106-.324-.17-.652-.34-.901-.59a17.931 17.931 0 0 1-.314-.461 10.078 10.078 0 0 0-.594-.833 5.468 5.468 0 0 0-2.526-1.648 15.912 15.912 0 0 1 2.31-6.198c.075-.014.15-.024.221-.035a1.82 1.82 0 0 0 .357-.073c.324-.18.627-.397.902-.647.232-.104.42-.035.59.034l.02.008c.21.081.4.154.625-.096.268-.298.122-.795-.018-1.269-.078-.265-.154-.524-.154-.736.01-.122.042-.24.093-.352A16.063 16.063 0 0 1 7.583 2.39c.128.135.227.295.288.47-.258.38-.383.836-.353 1.295a.851.851 0 0 0 .407.593 4.15 4.15 0 0 0 1.763-.593c.29-.058.593-.1.896-.143.314-.044.627-.088.924-.149.581-.118 1.916-1.193 1.444-2.012-.29-.118-.822-.303-.91-.293a6.544 6.544 0 0 1-2.57-.17l-.017.008A15.943 15.943 0 0 1 16 0a15.956 15.956 0 0 1 11.533 4.91c-.356-.01-.713.009-1.066.055a41.65 41.65 0 0 1-4.988.53c-.718 0-1.279-.264-1.819-.518-.5-.236-.983-.463-1.558-.463-.177 0-.362.02-.56.07a4.131 4.131 0 0 0-2 1.24c-.17.27-.177.499-.184.7-.009.28-.016.504-.46.711-.424-.199-.819-.457-1.172-.765a1.078 1.078 0 0 0-.82.472c-.027.366.099.573.227.784.122.2.246.403.246.748-.135.19-.36.306-.58.42-.253.13-.5.257-.591.492-.07.175-.084.389-.098.61-.022.33-.044.674-.256.92-.522.478-1.032.97-1.527 1.476a3.322 3.322 0 0 0 .236 4.01c.397.4.91.387 1.454.371h.008c.414-.01.847-.02 1.263.157.56.23.746 1.127.889 1.812.037.182.072.35.11.485.21.625.07 1.047-.08 1.495-.103.308-.21.628-.21 1.036 0 1.003.354 3.891 1.764 3.827 1.148-.039 1.648-.879 2.168-1.75.201-.338.405-.68.65-.983.391-.292.728-.65 1.001-1.057 0-.263.014-.544.027-.824.014-.28.027-.56.027-.824.212-.546.699-.883 1.18-1.217.322-.222.64-.443.874-.724.335-.405.302-.734.271-1.04-.022-.227-.044-.441.083-.666a.055.055 0 0 0 .04-.015.053.053 0 0 0 .016-.038c.472-.292.908-.53 1.471-.82.222-.286.458-.559.71-.82l.527-.172c1.01.506 1.26 1.32 1.503 2.117.195.638.387 1.263.96 1.708.06-.027.103-.056.146-.086.043-.03.085-.059.145-.085.097-.265.155-.542.173-.821a1.817 1.817 0 0 1 1.936-1.24 5.025 5.025 0 0 1 1.236 2.005c.067.404-.057.71-.176 1.006-.09.226-.178.445-.178.696.054.506.242.982.534 1.394v-.002c.59-1.669.915-3.462.915-5.332V16Zm-1.899-7.567Zm0 0a15.92 15.92 0 0 1 1.879 6.773l-.007-.123a15.943 15.943 0 0 0-1.872-6.65ZM.06 14.683A16.22 16.22 0 0 0 0 16.024V16c0-.8.059-1.585.172-2.353l-.012.096a15.81 15.81 0 0 0-.101.94Zm17.19-2.754c-.239-.016-.476-.031-.679-.064-.053 0-2.118-1.65-2.174-1.77a.702.702 0 0 1 .41-.41 5.677 5.677 0 0 1 1.473.912l.819.174c.168.136.339.252.515.371.129.087.26.176.395.276.359.128.735.209 1.116.236 0 .027.013.056.027.085.014.03.028.06.028.088v.292a1.94 1.94 0 0 0-.41.155 1.62 1.62 0 0 1-.91-.291h.002c-.191-.027-.402-.04-.612-.054Zm2.404 12.045a1.963 1.963 0 0 1 .999-1.596.53.53 0 0 1 .319.064c.444.648-.264 1.704-.91 1.942a.913.913 0 0 1-.409-.41Z"/></svg>',
                    tech_name: 'Ecosia',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://ecosia.org/',
                    },
                },
                {
                    tech_category: 'Website analytics',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16.245.002c-.85-.013-1.718.03-2.3.133-2.477.43-4.565 1.48-6.294 3.17C5.875 5.04 4.776 7.064 4.242 9.59l-.185.859-.046 21.549c.388.01.788-.052 1.122-.081 3.13-.382 5.792-2.278 7.242-5.153.366-.733.63-1.576.812-2.628.152-.892.16-1.189.136-5.841l-.024-4.898.19-.477c.263-.653.99-1.38 1.644-1.643l.476-.19 4.461-.008c2.453 0 4.606-.033 4.773-.065.78-.151 1.616-.804 1.95-1.529.096-.199.224-.588.28-.851.087-.438.08-.558-.047-1.052-.399-1.466-1.8-3.498-3.235-4.685-1.625-1.346-3.418-2.246-5.354-2.7-.51-.116-1.342-.183-2.192-.196ZM27.627 9.07c-.067.24-.13.488-.23.695a3.45 3.45 0 0 1-2.429 1.906c-4.898.076-3.385.075-4.898.076l-4.33.008-.36.143c-.418.168-1.103.853-1.27 1.27l-.144.357.023 4.768c.02 3.852.01 4.777-.08 5.5.69.123 1.39.185 2.09.185A11.986 11.986 0 0 0 27.627 9.07Z"/></svg>',
                    tech_name: 'Plausible',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://plausible.io/',
                    },
                },
            ],
        },
        code: {
            overline: 'Code',
            title: 'Modern tech and tools used to bring creative projects to life',
            content: [
                {
                    spans: [
                        {
                            start: 0,
                            end: 6,
                            type: "strong",
                        },
                        {
                            start: 10,
                            end: 17,
                            type: "strong",
                        },
                        {
                            start: 201,
                            end: 210,
                            type: "strong",
                        },
                    ],
                    text: 'NextJS and Gatsby are my go-to frameworks for front-end projects these days, having a ton of experience building out UI’s these allow me to use my existing knowledge to offer more. To build said UI’s, Storybook helps to keep all components organised.',
                    type: 'paragraph',
                },
                {
                    spans: [
                        {
                            start: 0,
                            end: 7,
                            type: "strong",
                        },
                        {
                            start: 176,
                            end: 190,
                            type: "strong",
                        },
                    ],
                    text: 'Prismic is my prefered headless CMS, offering a great pricing model with the ability to build component-driven pages. To add more complex animations, I’ve started playing with Framer Motion – opting for CSS animations for simple ones.',
                    type: 'paragraph',
                },
            ],
            tech: [
                {
                    tech_category: 'Framework',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M14.952 31.991c-.069-.006-.288-.028-.485-.043-4.545-.41-8.802-2.862-11.498-6.63a15.836 15.836 0 0 1-2.825-6.991C.016 17.448 0 17.188 0 15.997c0-1.192.016-1.451.144-2.33C1.014 7.659 5.29 2.61 11.089.74a16.918 16.918 0 0 1 3.378-.7c.485-.053 2.58-.053 3.066 0 2.149.238 3.97.77 5.765 1.686.275.14.328.178.29.21-.024.018-1.197 1.591-2.605 3.493l-2.559 3.456-3.206 4.744c-1.764 2.609-3.216 4.742-3.228 4.742-.013.003-.025-2.105-.031-4.68-.01-4.506-.013-4.687-.07-4.794a.568.568 0 0 0-.274-.284c-.1-.05-.188-.06-.66-.06h-.542l-.144.09a.585.585 0 0 0-.21.23l-.065.14.006 6.27.01 6.275.097.122c.05.065.156.15.231.19.129.063.179.07.72.07.638 0 .744-.026.91-.207.047-.05 1.783-2.665 3.86-5.814 2.077-3.15 4.917-7.45 6.312-9.561l2.534-3.838.128.084c1.136.739 2.337 1.79 3.288 2.884a15.925 15.925 0 0 1 3.766 8.179c.128.879.144 1.138.144 2.33 0 1.192-.016 1.451-.144 2.33-.87 6.008-5.146 11.056-10.945 12.926a16.8 16.8 0 0 1-3.331.698c-.3.031-2.368.065-2.628.04Zm6.55-9.676a.631.631 0 0 0 .316-.37c.025-.08.031-1.82.025-5.739l-.01-5.623-.99 1.52-.995 1.52v4.088c0 2.643.012 4.128.03 4.2.05.175.16.313.31.394.129.066.176.072.667.072.463 0 .544-.006.647-.062Z"/></svg>',
                    tech_name: 'NextJs',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://nextjs.org/',
                    },
                },
                {
                    tech_category: 'Framework',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0ZM7.086 24.914c-2.4-2.4-3.657-5.6-3.657-8.685L15.886 28.57c-3.2-.114-6.4-1.257-8.8-3.657Zm11.657 3.315L3.77 13.257C5.03 7.657 10.057 3.43 16 3.43c4.229 0 7.886 2.057 10.171 5.142l-1.714 1.486C22.514 7.43 19.43 5.714 16 5.714c-4.457 0-8.229 2.857-9.714 6.857l13.143 13.143c3.314-1.143 5.828-4 6.628-7.428h-5.486V16h8c0 5.943-4.228 10.971-9.828 12.229Z"/></svg>',
                    tech_name: 'Gatsby',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://gatsbyjs.com/',
                    },
                },
                {
                    tech_category: 'Hosting',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M14.436.038a16.344 16.344 0 0 0-8.475 3.48c-.99.839-1.897 1.771-2.708 2.784a16.345 16.345 0 0 0-3.115 7.466 19.23 19.23 0 0 0-.094 3.599 16.088 16.088 0 0 0 4.346 9.639 16.07 16.07 0 0 0 9.389 4.855c.92.137 2.677.181 3.596.094a16.07 16.07 0 0 0 9.634-4.35 16.087 16.087 0 0 0 4.852-9.393c.137-.92.181-2.679.094-3.599a16.013 16.013 0 0 0-3.49-8.668 20.27 20.27 0 0 0-2.784-2.71A16.382 16.382 0 0 0 18.22.12a24.703 24.703 0 0 0-3.784-.081Zm5.691 14.707 3.94 6.909-7.893.018c-4.34.007-7.899 0-7.912-.012-.012-.013 1.752-3.142 3.928-6.947a678.53 678.53 0 0 1 3.972-6.903l3.965 6.935Z"/></svg>',
                    tech_name: 'Vercel',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://vercel.com/',
                    },
                },
                {
                    tech_category: 'Hosting',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m23.192 11.105-.012-.005a.05.05 0 0 1-.02-.011.094.094 0 0 1-.023-.078l.646-3.944 3.029 3.026-3.15 1.339a.07.07 0 0 1-.028.005h-.012a.089.089 0 0 1-.017-.014 1.435 1.435 0 0 0-.413-.318Zm4.392-.24 3.239 3.234c.672.673 1.01 1.008 1.132 1.397.018.058.033.115.045.175l-7.74-3.274-.012-.005c-.03-.013-.067-.027-.067-.059 0-.031.037-.046.068-.059l.01-.004 3.325-1.405Zm4.284 5.844c-.167.314-.493.64-1.044 1.19l-3.651 3.647-4.723-.982-.025-.005c-.041-.007-.086-.014-.086-.052a1.423 1.423 0 0 0-.547-.995c-.02-.02-.014-.05-.008-.077l.001-.012.889-5.446.003-.019c.005-.042.012-.09.05-.09a1.447 1.447 0 0 0 .97-.555c.007-.008.012-.017.022-.022.026-.013.058 0 .086.011l8.062 3.407h.001Zm-5.535 5.676-6.004 5.997 1.028-6.31.001-.008.005-.024c.009-.02.03-.028.051-.037l.01-.004c.225-.096.424-.243.581-.431.02-.024.044-.046.075-.05a.07.07 0 0 1 .025 0l4.227.868v-.001Zm-7.275 7.266-.676.677L10.9 19.526a.248.248 0 0 0-.009-.011c-.011-.016-.024-.032-.021-.05 0-.014.009-.025.018-.035l.008-.011c.023-.034.042-.067.063-.103l.017-.029.002-.003c.012-.02.023-.039.043-.05.018-.008.042-.005.06 0l8.29 1.707a.138.138 0 0 1 .063.028c.011.01.014.022.016.035a1.467 1.467 0 0 0 .859.981c.023.012.013.038.002.065a.2.2 0 0 0-.012.038c-.104.634-1 6.09-1.24 7.563Zm-1.413 1.412c-.5.493-.793.754-1.126.86-.328.103-.68.103-1.007 0-.39-.124-.726-.46-1.399-1.132L6.6 23.285l1.962-3.04a.126.126 0 0 1 .033-.04c.021-.014.051-.007.077 0 .45.137.934.112 1.368-.068.023-.009.045-.015.063.001a.16.16 0 0 1 .023.027l7.519 10.898Zm-11.77-8.501L4.151 20.84l3.403-1.45a.069.069 0 0 1 .028-.006c.028 0 .045.028.06.054.034.053.07.104.109.154l.01.013c.01.014.004.028-.006.042l-1.88 2.915h-.002Zm-2.487-2.484L1.208 17.9c-.372-.37-.64-.64-.828-.87l6.63 1.373a.532.532 0 0 0 .026.004c.04.007.086.015.086.053 0 .042-.05.06-.091.077l-.02.008-3.623 1.533ZM0 15.91c.007-.14.033-.28.075-.414.124-.389.46-.724 1.133-1.397l2.79-2.787c1.285 1.863 2.574 3.723 3.865 5.58.023.03.048.064.022.089a2.318 2.318 0 0 0-.33.44.133.133 0 0 1-.042.052c-.01.007-.022.005-.035.002h-.001L0 15.91Zm4.745-5.344 3.752-3.748c.353.154 1.637.696 2.784 1.18.87.367 1.661.7 1.91.81.025.01.048.02.059.044.007.015.003.035 0 .05a1.67 1.67 0 0 0 .437 1.526c.025.025 0 .06-.022.092l-.012.017-3.81 5.895a.115.115 0 0 1-.035.042c-.02.012-.049.006-.072 0-.148-.038-.3-.06-.454-.061-.137 0-.286.025-.436.052-.018.003-.033.006-.046-.004a.175.175 0 0 1-.038-.042l-4.017-5.853Zm4.51-4.505 4.858-4.852C14.786.537 15.124.2 15.512.078c.328-.104.68-.104 1.008 0 .39.122.726.459 1.399 1.13L18.97 2.26l-3.455 5.344a.13.13 0 0 1-.034.04c-.021.014-.05.008-.076 0a1.754 1.754 0 0 0-1.604.309c-.022.023-.056.01-.084-.003-.451-.196-3.96-1.677-4.462-1.89Zm10.449-3.068 3.19 3.186-.769 4.756v.012c0 .01-.003.022-.007.032-.008.017-.024.02-.041.025a1.528 1.528 0 0 0-.475.242c-.009.01-.018.02-.033.02a.095.095 0 0 1-.036-.005l-4.861-2.063-.01-.004c-.03-.013-.067-.028-.067-.06a1.831 1.831 0 0 0-.259-.763c-.023-.039-.05-.079-.03-.118l3.398-5.26Zm-3.287 7.181 4.557 1.928c.025.012.052.023.063.048a.087.087 0 0 1 0 .048 1.128 1.128 0 0 0-.025.22v.127c0 .032-.032.045-.062.058l-.01.003c-.721.308-10.134 4.318-10.148 4.318-.014 0-.03 0-.044-.015-.025-.025 0-.06.023-.091a.627.627 0 0 0 .012-.017l3.744-5.792.007-.01c.022-.035.047-.074.087-.074l.037.005c.086.012.16.023.237.023.568 0 1.094-.276 1.412-.749a.13.13 0 0 1 .028-.033c.023-.017.056-.008.082.003ZM11.2 17.84l10.26-4.37s.014 0 .029.013c.056.056.103.094.15.129l.022.014c.02.012.042.025.043.047l-.001.02-.878 5.394-.004.022c-.006.042-.012.09-.05.09a1.445 1.445 0 0 0-1.148.706l-.004.007c-.012.02-.023.038-.042.048-.017.008-.04.005-.058 0l-8.182-1.685c-.009-.002-.127-.433-.136-.434l-.001-.001Z"/></svg>',
                    tech_name: 'Netlify',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://netlify.com/',
                    },
                },
                {
                    tech_category: 'CMS',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m29.23 14.293 2.36 2.365a.2.2 0 0 0 .34-.14v-6.263c0-3.565-.37-4.859-1.066-6.163a7.261 7.261 0 0 0-3.017-3.024C26.546.372 25.255 0 21.697 0H20.37a.996.996 0 0 0-.706.293l-2.36 2.366a.2.2 0 0 0 .14.341h3.818c2.668 0 3.636.278 4.612.802a5.447 5.447 0 0 1 2.263 2.267c.521.978.8 1.948.8 4.622v2.895a1 1 0 0 0 .292.707ZM17.668 29.294l-2.36 2.365a.2.2 0 0 0 .14.34h6.248c3.558 0 4.849-.37 6.15-1.067a7.262 7.262 0 0 0 3.017-3.024c.696-1.304 1.067-2.597 1.067-6.162v-1.331c0-.265-.106-.52-.293-.708l-2.36-2.365a.2.2 0 0 0-.341.141v3.826c0 2.675-.278 3.645-.8 4.622a5.446 5.446 0 0 1-2.263 2.268c-.976.523-1.943.802-4.612.802h-2.888a.996.996 0 0 0-.705.293ZM.34 15.341l2.362 2.366c.187.187.293.442.293.707v2.894c0 2.675.277 3.645.8 4.623a5.446 5.446 0 0 0 2.262 2.267C7.033 28.722 8 29 10.669 29h3.817a.2.2 0 0 1 .143.341l-2.362 2.366a.996.996 0 0 1-.705.293h-1.328c-3.558 0-4.848-.372-6.15-1.069a7.26 7.26 0 0 1-3.017-3.024C.37 26.604 0 25.31 0 21.745v-6.262a.2.2 0 0 1 .34-.142ZM13.556 3a.998.998 0 0 0 .706-.293L16.622.34a.2.2 0 0 0-.14-.341h-6.25C6.677 0 5.386.372 4.085 1.068a7.261 7.261 0 0 0-3.017 3.024C.37 5.396 0 6.69 0 10.255v1.33c0 .266.106.52.293.708l2.36 2.366a.2.2 0 0 0 .34-.142v-3.825c0-2.675.278-3.645.8-4.623a5.446 5.446 0 0 1 2.263-2.267C7.032 3.278 8 3 10.668 3h2.889Zm13.047 8.677-3.217-3.083a1.992 1.992 0 0 0-.728-.465A1.987 1.987 0 0 0 21.952 8h-9.499a.2.2 0 0 1-.141-.341l2.363-2.367A.997.997 0 0 1 15.38 5h7.57a3.996 3.996 0 0 1 3.991 4v2.533a.2.2 0 0 1-.338.144Zm-3.248 11.761-3.076 3.226a.2.2 0 0 0 .144.339h2.527a3.996 3.996 0 0 0 3.991-4v-7.586c0-.266-.104-.52-.291-.708l-2.361-2.368a.2.2 0 0 0-.308.03.2.2 0 0 0-.034.112v9.52a2 2 0 0 1-.127.706 1.987 1.987 0 0 1-.465.73ZM5.326 20.324l3.22 3.082c.212.213.462.368.727.465.218.084.457.129.706.129h9.498a.2.2 0 0 1 .195.24.201.201 0 0 1-.054.101l-2.363 2.366a.999.999 0 0 1-.705.293H8.98a3.997 3.997 0 0 1-3.99-4v-2.532a.2.2 0 0 1 .337-.145Zm3.249-11.76 3.076-3.226a.199.199 0 0 0-.034-.305.2.2 0 0 0-.11-.033H8.98a3.996 3.996 0 0 0-3.99 4v7.586c0 .265.104.519.29.707l2.362 2.367a.2.2 0 0 0 .34-.14V10a2 2 0 0 1 .129-.707c.097-.266.25-.515.464-.729Z"/></svg>',
                    tech_name: 'Prismic',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://prismic.io/',
                    },
                },
                {
                    tech_category: 'Pattern library',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m21.366 3.933.15-3.626-17.608 1.1a1.609 1.609 0 0 0-1.507 1.666l.991 26.414c.032.837.7 1.51 1.536 1.547l21.475.964c.024.002.048.002.072.002.889 0 1.61-.72 1.61-1.609V1.61a1.609 1.609 0 0 0-1.71-1.606l-1.767.11.13 3.693a.24.24 0 0 1-.389.197l-1.19-.937-1.408 1.068a.24.24 0 0 1-.385-.2Zm.836 8.014c-.566.44-4.782.74-4.782.114.089-2.388-.98-2.493-1.574-2.493-.565 0-1.515.17-1.515 1.45 0 1.304 1.389 2.04 3.02 2.904 2.315 1.228 5.119 2.713 5.119 6.451 0 3.583-2.911 5.562-6.624 5.562-3.832 0-7.18-1.55-6.803-6.925.149-.631 5.02-.481 5.02 0-.059 2.218.446 2.87 1.723 2.87.98 0 1.426-.54 1.426-1.45 0-1.377-1.447-2.19-3.112-3.124-2.255-1.266-4.908-2.756-4.908-6.174 0-3.412 2.347-5.687 6.535-5.687 4.188 0 6.475 2.24 6.475 6.502Z"/></svg>',
                    tech_name: 'Storybook',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://storybook.js.org/',
                    },
                },
                {
                    tech_category: 'Animation library',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M2.133 27.733V3.698L16 15.716 29.867 3.697v24.035l-6.934-6.009L16 27.734l-6.933-6.01-6.934 6.01Z"/></svg>',
                    tech_name: 'Framer motion',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://storybook.js.org/',
                    },
                },
                {
                    tech_category: 'Code editor',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2722:2543)"><path d="M30.867 3.45 24.28.28a1.992 1.992 0 0 0-2.273.387L9.393 12.174 3.9 8.003a1.332 1.332 0 0 0-1.701.076L.436 9.682a1.333 1.333 0 0 0-.001 1.972L5.199 16 .435 20.347a1.334 1.334 0 0 0 .001 1.972L2.2 23.92a1.332 1.332 0 0 0 1.701.076l5.494-4.17 12.613 11.506a1.99 1.99 0 0 0 2.272.387l6.59-3.17A2 2 0 0 0 32 26.748V5.252a2 2 0 0 0-1.133-1.802Zm-6.862 19.814L14.435 16l9.57-7.264v14.528Z"/></g><defs><clipPath id="clip0_2722:2543"><rect width="32" height="32" fill="white"/></clipPath></defs></svg>',
                    tech_name: 'VS Code',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://code.visualstudio.com/',
                    },
                },
                {
                    tech_category: 'Version control',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 .396c-8.84 0-16 7.164-16 16 0 7.071 4.584 13.067 10.94 15.18.8.151 1.093-.343 1.093-.769 0-.38-.013-1.386-.02-2.72-4.45.965-5.389-2.146-5.389-2.146-.728-1.847-1.78-2.34-1.78-2.34-1.45-.992.112-.973.112-.973 1.607.113 2.45 1.648 2.45 1.648 1.427 2.447 3.746 1.74 4.66 1.331.145-1.034.557-1.74 1.014-2.14-3.553-.4-7.288-1.776-7.288-7.906 0-1.747.62-3.174 1.647-4.294-.18-.404-.72-2.03.14-4.235 0 0 1.34-.429 4.4 1.64 1.28-.356 2.64-.532 4-.54 1.36.008 2.72.184 4 .54 3.04-2.069 4.38-1.64 4.38-1.64.86 2.204.32 3.831.16 4.235 1.02 1.12 1.64 2.547 1.64 4.293 0 6.147-3.74 7.5-7.3 7.894.56.48 1.08 1.461 1.08 2.96 0 2.141-.02 3.861-.02 4.381 0 .42.28.92 1.1.76C27.42 29.456 32 23.456 32 16.396c0-8.836-7.164-16-16-16"/></svg>',
                    tech_name: 'GitHub',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://github.com/',
                    },
                },
                {
                    tech_category: 'Terminal',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M18.087 23.88H32V26.5H18.087V23.88Zm-4.268-6.786-12.25 10.67 3.814-9.338L0 14.906l12.25-10.67-4.147 9.935 5.716 2.923Z"/></svg>',
                    tech_name: 'Hyper',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://hyper.is/',
                    },
                },
            ],
        },
        design: {
            overline: 'Design',
            title: 'From writing to prototyping and fully-fledged designs, these are my go-to design tools',
            content: [
                {
                    spans: [
                        {
                            start: 0,
                            end: 5,
                            type: "strong",
                        },
                        {
                            start: 155,
                            end: 166,
                            type: "strong",
                        },
                    ],
                    text: 'Figma is a powerhouse in the design space – using it for hi-fi wireframes, interactive prototypes and fully designed UIs. For personal projects, I head to Adobe Fonts for beautifully designed web fonts.',
                    type: 'paragraph',
                },
                {
                    spans: [
                        {
                            start: 90,
                            end: 98,
                            type: "strong",
                        },
                        {
                            start: 154,
                            end: 163,
                            type: "strong",
                        },
                    ],
                    text: 'For design inspiration, I have a collection of designs I’ve added to over the years in my Raindrop mood board. When it comes to writing content I rely on Grammarly to take my writing to the next level or just catch grammatical errors.',
                    type: 'paragraph',
                },
            ],
            tech: [
                {
                    tech_category: 'Design',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M21.136 11.975h-6.117V0h6.117a5.993 5.993 0 0 1 5.987 5.987 5.994 5.994 0 0 1-5.987 5.988Zm-4.156-1.962h4.156a4.03 4.03 0 0 0 4.025-4.025 4.031 4.031 0 0 0-4.025-4.025H16.98v8.05Zm0 1.962h-6.116a5.993 5.993 0 0 1-5.987-5.987A5.994 5.994 0 0 1 10.864 0h6.117v11.975h-.001ZM10.864 1.96a4.03 4.03 0 0 0-4.025 4.026 4.031 4.031 0 0 0 4.025 4.026h4.156V1.961h-4.156Zm6.116 20.026h-6.116A5.993 5.993 0 0 1 4.877 16a5.993 5.993 0 0 1 5.987-5.987h6.117v11.974h-.001Zm-6.116-10.012A4.03 4.03 0 0 0 6.839 16a4.031 4.031 0 0 0 4.025 4.025h4.156v-8.05h-4.156ZM10.896 32c-3.319 0-6.02-2.685-6.02-5.987a5.993 5.993 0 0 1 5.987-5.986h6.117v5.921c0 3.337-2.73 6.052-6.084 6.052Zm-.032-10.013a4.03 4.03 0 0 0-4.025 4.025c0 2.22 1.82 4.025 4.058 4.025 2.274 0 4.124-1.834 4.124-4.09v-3.96h-4.157Zm10.272 0h-.13A5.993 5.993 0 0 1 15.018 16a5.993 5.993 0 0 1 5.986-5.987h.131A5.993 5.993 0 0 1 27.123 16a5.993 5.993 0 0 1-5.987 5.987Zm-.13-10.012A4.03 4.03 0 0 0 16.982 16a4.031 4.031 0 0 0 4.026 4.025h.13A4.03 4.03 0 0 0 25.163 16a4.031 4.031 0 0 0-4.026-4.025h-.13Z"/></svg>',
                    tech_name: 'Figma',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://figma.com/',
                    },
                },
                {
                    tech_category: 'Moodboard',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.914 13.18c-.194-2.44-1.252-4.829-3.174-6.696-4.274-4.154-11.206-4.154-15.482 0a10.467 10.467 0 0 0-3.173 6.697 7.998 7.998 0 0 0-2.742 13.107A8 8 0 0 0 8 28.631h16a8 8 0 0 0 2.914-15.45Z"/></svg>',
                    tech_name: 'Raindrop',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://raindrop.io/',
                    },
                },
                {
                    tech_category: 'Fonts',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M26.352.5H5.648A5.648 5.648 0 0 0 0 6.148v19.705a5.648 5.648 0 0 0 5.648 5.648h20.704A5.648 5.648 0 0 0 32 25.852V6.147A5.648 5.648 0 0 0 26.352.5Zm-4.333 8.715c-.323 0-.486-.242-.587-.586-.343-1.293-.787-1.676-1.05-1.676-.262 0-.666.486-1.11 1.494a25.733 25.733 0 0 0-1.343 3.992l2.31-.003a.87.87 0 0 1-.318 1.03H17.64c-.747 2.503-1.375 4.917-2.123 7.28a12.9 12.9 0 0 1-1.473 3.413 4.192 4.192 0 0 1-3.312 1.776c-1.03 0-2.04-.484-2.04-1.555a1.404 1.404 0 0 1 1.232-1.293.613.613 0 0 1 .565.324c.506.909.99 1.433 1.212 1.433.222 0 .404-.303.767-1.615l2.65-9.762-1.906-.003a.913.913 0 0 1 .303-1.032h1.897a17.562 17.562 0 0 1 1.397-3.44 5.048 5.048 0 0 1 4.363-2.927c1.515 0 2.14.727 2.14 1.656a1.526 1.526 0 0 1-1.293 1.494Z"/></svg>',
                    tech_name: 'Adobe Fonts',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://fonts.adobe.com/',
                    },
                },
                {
                    tech_category: 'Writing',
                    tech_icon: '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M32 16c0 8.836-7.164 16-16 16S0 24.836 0 16C0 7.163 7.164 0 16 0c8.837 0 16 7.163 16 16Zm-12.844 2.168a1.074 1.074 0 0 0-.834.391 1.089 1.089 0 0 0-.231.896c.094.524.586.882 1.12.882h1.676l.972-.136c-1.555 2.28-4.254 3.331-7.207 2.867-2.403-.376-4.467-2.003-5.337-4.273C7.337 13.64 11.1 8.72 16.008 8.72c2.555 0 4.797 1.496 6.083 3.304.369.52 1.017.672 1.51.33a1.067 1.067 0 0 0 .315-1.425h.008a9.387 9.387 0 0 0-8.567-4.31c-4.677.314-8.462 4.142-8.733 8.822-.31 5.448 4.01 9.895 9.383 9.895a9.303 9.303 0 0 0 7.072-3.217l-.204 1.14v1.03c0 .534.358 1.027.882 1.12a1.085 1.085 0 0 0 1.286-1.066v-6.174h-5.887"/></svg>',
                    tech_name: 'Grammarly',
                    tech_url: {
                        link_type: 'Web',
                        url: 'https://grammarly.com/',
                    },
                },
            ],
        },
        cta: {
            background: true,
            items: [
                {
                    content_media_alignment: 'rtl',
                    content_media_button_text: {
                        text: 'See if I can help you',
                    },
                    content_media_button_url: {
                        link_type: 'Web',
                        url: 'https://robsimpson.digital',
                    },
                    content_media_content: {
                        text: 'On the off chance that you need help with a project, feel free to check out my business site and drop me a message if you think we’d be a good fit – even if I’m booked up I can try and put you in touch with others who might be able to help!',
                    },
                    content_media_image: {
                        alt: '',
                        dimensions: {
                            height: 884,
                            width: 1180,
                        },
                        url: 'https://images.prismic.io/robsimpson/d37c0fb8-70b3-4eeb-9ffc-703b17e77e00_Listing+Rob+Simpson+Small.png?auto=compress,format'
                    },
                    content_media_title: {
                        text: 'Looking for a freelance designer or developer?',
                    },
                },
            ],
        },
        books: {
            description: 'Some of my favourite business books that I’ve read over the years which have helped me on my freelance journey.',
            items: [
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/00bebc52-7698-46b4-85a3-698d29d58194_wwopm.png?auto=compress,format'
                    },
                    book_rating: 4,
                    book_title: {
                        text: 'The win without pitching manifesto',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/Win-Without-Pitching-Manifesto/dp/1605440043',
                    },
                },
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/26064735-d182-471a-9079-2417f1d8775d_csbd.png?auto=compress,format'
                    },
                    book_rating: 3,
                    book_title: {
                        text: 'Creative strategy and the business of design',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/Creative-Strategy-Business-Design-Douglas/dp/1440341559',
                    },
                },
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/b26c7089-d54c-47eb-be3e-63b73456e554_brutally-honest.png?auto=compress,format'
                    },
                    book_rating: 3,
                    book_title: {
                        text: 'Brutally honest',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://emilycohen.com/brutally-honest/',
                    },
                },
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/d788603c-a705-4542-b762-c5cc07141753_sell-or-be-sold.png?auto=compress,format'
                    },
                    book_rating: 4,
                    book_title: {
                        text: 'Sell or be sold',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://amazon.co.uk/Sell-Be-Sold-Your-Business/dp/B00JU4SA9K/',
                    },
                },
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/bf6cef4d-6e1f-4a8f-91a2-51fafb8d9c14_cash-money-freelancing.png?auto=compress,format'
                    },
                    book_rating: 3,
                    book_title: {
                        text: 'Cash money freelancing',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://www.amazon.co.uk/Cash-Money-Freelancing-freelance-business/dp/1838054561',
                    },
                },
                {
                    book_image: {
                        alt: '',
                        dimensions: {
                            height: 240,
                            width: 160,
                        },
                        url: 'https://images.prismic.io/robsimpson/6bc08a6a-0891-41a5-b0d5-790bf3e891e1_nstd.png?auto=compress,format'
                    },
                    book_rating: 3,
                    book_title: {
                        text: 'Never split the difference',
                    },
                    book_url: {
                        link_type: 'Web',
                        url: 'https://amazon.co.uk/Never-Split-Difference-Negotiating-Depended/dp/B07T7L39TN/',
                    },
                },
            ],
            title: 'Favourite business books',
        },
    };

    return (
        <Shell
            pageDescription={data.masthead.description[0].text}
            pageSocialImage="https://images.prismic.io/robsimpson/cbc39b3e-aec4-46b5-8f97-8dc1d358dd7c_Social+Share+Business.jpg"
            pageTitle={data.masthead.title}
            pathname={pathname}
        >
            <SubHeader
                navLinkTitle="Explore"
                navLinks={[
                    {
                        nav_link_text: {
                            text: 'Office',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#office',
                        },
                    },
                    {
                        nav_link_text: {
                            text: 'Money',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#money',
                        },
                    },
                    {
                        nav_link_text: {
                            text: 'Management',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#management',
                        },
                    },
                    {
                        nav_link_text: {
                            text: 'Code',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#code',
                        },
                    },
                    {
                        nav_link_text: {
                            text: 'Design',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#design',
                        },
                    },
                    {
                        nav_link_text: {
                            text: 'Books',
                        },
                        nav_link_url: {
                            link_type: 'Document',
                            uid: 'business#favourite-business-books',
                        },
                    },
                ]}
                navCtaEmoji="👝"
                navCtaText="Freelance business"
                navCtaUrl={{
                    link_type: 'Web',
                    url: 'https://robsimpson.digital/',
                }}
            />
            <Masthead
                description={data.masthead.description}
                image={data.masthead.image}
                subheader={true}
                title={data.masthead.title}
            />
            <BlogList
                items={data.blog.items}
            />
            <ProductBlock
                overline={data.office.overline}
                title={data.office.title}
                content={data.office.content}
                media={data.office.media}
                products={data.office.products}
            />
            <TechBlock
                overline={data.money.overline}
                title={data.money.title}
                content={data.money.content}
                tech={data.money.tech}
            />
            <TechBlock
                overline={data.management.overline}
                title={data.management.title}
                content={data.management.content}
                tech={data.management.tech}
            />
            <TechBlock
                overline={data.code.overline}
                title={data.code.title}
                content={data.code.content}
                tech={data.code.tech}
            />
            <TechBlock
                overline={data.design.overline}
                title={data.design.title}
                content={data.design.content}
                tech={data.design.tech}
            />
            <ContentMediaListBlock
                background={data.cta.background}
                items={data.cta.items}
            />
            <BookListBlock
                description={data.books.description}
                items={data.books.items}
                title={data.books.title}
            />
        </Shell>
    );
}

export default BusinessLandingPage;
